export default __webpack_public_path__ + "static/CenturyGothic-Bold-Italic-2c8a0a65aca1023c8476d4d126bdc125.ttf";